/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-17 10:05:35
 */ 
export const databaseCn = {
    shouye:'首页',
    zlglb:'资料库列表',
    genduo:'更多',
    rzfwgjz:'请输入资料关键字',
    jiansuo:'检索',
    sousuo:'搜索',
    xinxileixin:'信息类型',
    qzxcprz:'强制性产品认证',
    faburiqi:'发布日期',
    xunzheriqi:'选择日期',
    zlg:'资料库',
    zlxq:'资料详情',
    weisc:'未收藏',
    yisc:'已收藏',
    zhiding:'置顶',
    renzhengzx: "认证资讯",
    henyeguifan: "行业规范",
    zhengcefagui: "政策法规",
    biaozhunziliao: "标准资料",
    caipingzhaohui: "产品召回",
}


// WEBPACK FOOTER //
// ./src/lang/home/database/indexCn.js